export default "__VITE_ASSET__CG4tqpfb__"